import { Injectable } from "@angular/core";
import { CanActivate, ActivatedRouteSnapshot, Router } from "@angular/router";

@Injectable({ providedIn: "root" })
export class OrderActionGuard implements CanActivate {
    private allowedActions = ["cancel", "return", "exchange"];

    constructor(private router: Router) {}

    canActivate(route: ActivatedRouteSnapshot): boolean {
        const action = route.paramMap.get("action");
        if (action && this.allowedActions.includes(action)) {
            return true;
        }

        this.router.navigate(["/page-not-found"]);
        return false;
    }
}
